var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('topbar'),_c('hero'),(_vm.isDesktop)?_c('sect',{staticClass:"features"},[_c('wrap',{staticClass:"rel"},_vm._l((_vm.features),function(ref,index){
var title = ref.title;
var text = ref.text;
var icon = ref.icon;
return _c('feature',{key:title,attrs:{"title":title,"texts":[text],"icon":icon,"index":index}})})),_c('div',{staticClass:"overlay"})],1):_vm._e(),_c('sect',{staticClass:"showcase"},_vm._l((_vm.showcase),function(ref,index){
var text = ref.text;
var image = ref.image;
var title = ref.title;
return _c('home-sect',{key:index,class:{ first: index === 0, last: index === (_vm.showcase.length - 1) },attrs:{"image":image,"index":index + 1,"text":text,"title":title}})})),_c('sect',{staticClass:"signup"},[_c('btn',{staticClass:"ib lg round info",attrs:{"to":"Signup"}},[_vm._v("\n      Signup\n    ")])],1),_c('sect',{staticClass:"footer"},[_c('wrap',[_vm._v("\n      Copyright © "+_vm._s(_vm._f("year")(new Date()))+" Jobcarda\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94e29c30","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = 358
// module chunks = 8